import { subMonths, startOfMonth, endOfMonth, format } from "date-fns";
import { TOP10_CHART, DASHBOARD_CHART_DEFINITION } from "@/misc/desktopCharts";
import { getDataByStartAndEndDate, getTotalByMonth } from "./lib/callChartAPI";
import normalizeFiltersForAPI from "@/lib/normalizeFilters";

const getChartDataAndTotalUsingDiffAPI = async (chartName, currentDate, storeId, filters) => {
  const prevMonthDate = subMonths(currentDate, 1);
  const responses = await Promise.all([
    getDataByStartAndEndDate(chartName, startOfMonth(currentDate), endOfMonth(currentDate), storeId, filters),
    getTotalByMonth(chartName, format(currentDate, "yMM"), storeId, filters),
    getTotalByMonth(chartName, format(prevMonthDate, "yMM"), storeId, filters),
  ]);
  return {
    data: responses[0].data || [],
    total: responses[1].data.val || "n/a",
    prevTotal: responses[2].data.val || 0,
  };
};

const getChartDataWithTotalAtSameTime = async (chartName, currentDate, storeId, filters) => {
  const prevMonthDate = subMonths(currentDate, 1);
  const responses = await Promise.all([
    getDataByStartAndEndDate(chartName, startOfMonth(currentDate), endOfMonth(currentDate), storeId, filters),
    getDataByStartAndEndDate(chartName, startOfMonth(prevMonthDate), endOfMonth(prevMonthDate), storeId, filters),
  ]);
  return {
    data: responses[0].data || [],
    total: responses[0].total || "n/a",
    prevTotal: responses[1].total || 0,
  };
};

const top10Chart = async (chartName, currentDate, storeId, filters) => {
  const topItems = await getTotalByMonth(chartName, format(currentDate, "yMM"), storeId, filters);
  return topItems?.data?.rank || [];
};

export default async (chartName, currentDate, storeId, filters) => {
  const normalizedFilters = normalizeFiltersForAPI(filters);
  if (chartName === "vs-coverage-rate") delete normalizedFilters["c"]; // remove item category filter for coverage API call
  if (chartName === TOP10_CHART) {
    return {
      data: await top10Chart(chartName, currentDate, storeId, normalizedFilters),
    };
  }

  const chartDefine = DASHBOARD_CHART_DEFINITION.find((define) => define.name === chartName);
  if (chartDefine.callAPIWithMonthParam) {
    return getChartDataAndTotalUsingDiffAPI(chartName, currentDate, storeId, normalizedFilters);
  } else {
    return getChartDataWithTotalAtSameTime(chartName, currentDate, storeId, normalizedFilters);
  }
};
